<script>
    import _ from 'lodash'
    import Vue from 'vue'
    import Vuex from 'vuex'
    import algoliasearch from 'algoliasearch/lite'

    const store = new Vuex.Store({
        state: {
            hits: []
        },
        getters: {
            hits: state => {
                return state.hits
            }
        },
        mutations: {
            result (state, payload) {
                Vue.set(state, 'total', payload.nbHits)
                Vue.set(state, 'hits', payload.hits)
            }
        }
    })

    export default {
        props: {
            perPage: {
                type: Number,
                default: 10
            },
            preloaded: {
                type: [Object, null],
                default: null
            },
            searchOnCreated: {
                type: [String, null],
                default: null
            }
        },
        computed: {
            client () {
                return algoliasearch.initPlaces(
                    _.preload('keys.algolia-places.app-id'),
                    _.preload('keys.algolia-places.key')
                )
            }
        },
        created () {
            if (this.preloaded) {
                store.commit('result', this.preloaded)

                this.$emit('success', this.preloaded, true)
            }

            if (this.searchOnCreated) {
                this.search(this.searchOnCreated)
            }
        },
        methods: {
            search (query, callback = null) {
                this.client
                    .search({
                        query,
                        hitsPerPage: this.perPage,
                        countries: 'gb',
                        language: 'en',
                        aroundLatLngViaIP: true
                    })
                    .then(result => {
                        store.commit('result', result)

                        if (callback) callback()

                        this.$emit('success', result, false)
                    })
            }
        },
        render () {
            return this.$scopedSlots.default({
                data: store.state ? store.state.hits : [],
                search: this.search
            })
        }
    }
</script>
